import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function Header() {
  const { pathname } = useLocation();
  const headerTitle = useMemo(() => {
    if (pathname === '/' || pathname === '/dashboard') {
      return 'KULUM';
    }
    if (pathname.startsWith('/search')) {
      return '検索';
    }
    if (pathname.startsWith('/messages')) {
      return 'メッセージ';
    }
    if (
      pathname.startsWith('/mypage') ||
      pathname.startsWith('/reviews') ||
      pathname.startsWith('/requests')
    ) {
      return 'マイページ';
    }
    return 'KULUM';
  }, [pathname]);
  const isHomeHeader = headerTitle === 'KULUM';

  return (
    <header className="fixed top-0 left-0 right-0 md:left-64 z-40 bg-white/80 backdrop-blur-md border-b border-neutral-100">
      <div className="safe-area-top">
        <div className="container mx-auto px-4 h-14 md:h-16 flex items-center justify-center">
          <h1
            className={`font-heading font-bold text-luxury-dark ${
              isHomeHeader ? 'text-lg md:text-xl tracking-[0.15em]' : 'text-base md:text-lg'
            }`}
          >
            {headerTitle}
          </h1>
        </div>
      </div>
    </header>
  );
}
